import React from "react";

const imageLogo = {
  faqlogo1: "https://lagunaproperty.com/images/faqlogo1.png",
  faqlogo2: "https://lagunaproperty.com/images/faqlogo2.png",
  faqlogo3: "https://lagunaproperty.com/images/faqlogo3.png",
  faqlogo4: "https://lagunaproperty.com/images/faqlogo4.png",
  faqlogo5: "https://lagunaproperty.com/images/faqlogo5.png",
};

const category = [
  { id: 1, name: "Sanctuary Club", displayOn: ["en", "cn", "ru"] },
  { id: 2, name: "Exchange Programme", displayOn: ["en", "cn", "ru"] },
  { id: 3, name: "Terms and Conditions", displayOn: ["en", "cn", "ru"] },
];

const faqs = [
  {
    categoryId: 1,
    question: "How do I enroll?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Enrollment into The Santuary Club is complimentary for Banyan Tree,
            Angsana, Cassia and Laguna Property owners who have their property
            managed under a hotel /anded rental scheme.
          </p>
        </div>
      ),
      ru: <div />,
      cn: <div />,
    },
  },
  {
    categoryId: 1,
    question: "What are the benefits of The Santuary Club?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Participating owners can exchange part of their annual entitlement
            for a complimentary stay at any destination within the network. In
            addition, discounts and special privileges are offered to owners
            with the standard discounts (1) and privileges are listed below
            (terms and conditions apply):
          </p>
          <ul>
            <li>
              - 30% discount on best available rates for hotel accommodation{" "}
              <sup>(2)</sup>
            </li>
            <li>
              - 30% discount on golf green fees <sup>(3)</sup>
            </li>
            <li>
              - 25% discount on food and beverage<sup>(4)</sup>
            </li>
            <li>
              - 20% discount on a-la-carte spa menu
              <sup />
            </li>
            <li>
              - 15% discount on gallery merchandise<sup>(5)</sup>
            </li>
            <li>
              - 15% discount on in-house tours <sup>(6)</sup>
            </li>
            <li>
              - 15% discount on laundry
              <sup />
            </li>
            <li>
              - 10% discount on airport and ferry terminal transfers{" "}
              <sup>(7)</sup>
            </li>
            <li>
              - Priority wait-list on reservations
              <sup />
            </li>
            <li>
              - Early check-in / late check-out <sup>(8)</sup>
            </li>
            <li>
              - Invitations to Xperential Guest Program (i.e. pre-opening /
              trial stays at new resorts)
              <sup />
            </li>
          </ul>
          <ol>
            <li>
              <small>
                <sup>(1)</sup> Higher discounts may apply at certain times and
                locations and may be subject to change without notice
              </small>
            </li>
            <li>
              <small>
                <sup>(2)</sup> Best available rate at time of booking
              </small>
            </li>
            <li>
              <small>
                <sup>(3)</sup> Phuket, Bintan and Lăng Cô only
              </small>
            </li>
            <li>
              <small>
                <sup>(4)</sup> Offers cannot be combined. Discounts may not
                apply to festive and special occasions.
              </small>
            </li>
            <li>
              <small>
                <sup>(5)</sup> Not applicable to consignment items
              </small>
            </li>
            <li>
              <small>
                <sup>(6)</sup> Selected destinations only
              </small>
            </li>
            <li>
              <small>
                <sup>(7)</sup> Selected destinations only
              </small>
            </li>
            <li>
              <small>
                <sup>(8)</sup> Subject to availability on day of arrival /
                departure
              </small>
            </li>
          </ol>
          <p>
            Kindly present your Sanctuary Club card to avail the discounts and
            privileges.
          </p>
        </div>
      ),
      ru: <div />,
      cn: <div />,
    },
  },
  {
    categoryId: 1,
    question:
      "Can I receive discounts at Banyan Tree, Angsana, and Laguna Resorts even if I am not staying there and would like to visit the hotel for any meals?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Yes, you can receive discounts at all Banyan Tree, Angsana, and
            Laguna Resorts even if you are not staying in the resort, as long as
            you present your card prior to payment.
          </p>
          <table
            cellpadding="5"
            style={{
              verticalAlign: "top",
              margin: 0,
              borderColor: "transparent",
              backgroundColor: "#ffffff",
              width: "100%",
            }}
          >
            <tbody>
              <tr>
                <td
                  style={{ verticalAlign: "top", borderColor: "transparent" }}
                  width="150"
                >
                  <img src={imageLogo.faqlogo1} width="120" alt="" />
                </td>
                <td
                  style={{ verticalAlign: "top", borderColor: "transparent" }}
                >
                  <strong>China</strong>
                  <br />
                  Anji
                  <br />
                  Chongqing Beibei
                  <br />
                  Huangshan
                  <br />
                  Hangzhou
                  <br />
                  Jiuzhaigou
                  <br />
                  Lijiang
                  <br />
                  Macau
                  <br />
                  Ringha
                  <br />
                  Sanya
                  <br />
                  Tengchong
                  <br />
                  Tianjin Riverside
                  <br />
                  Yangshuo
                  <br />
                </td>
                <td
                  style={{ verticalAlign: "top", borderColor: "transparent" }}
                >
                  <strong>Thailand</strong>
                  <br />
                  Bangkok
                  <br />
                  Phuket Double Pool Villas
                  <br />
                  Phuket Resort
                  <br />
                  Phuket Spa Sanctuary
                  <br />
                  Samui
                  <br />
                  <br />
                  <strong>Indonesia</strong> <br />
                  Bintan
                  <br />
                  Ungasan, Bali
                  <br />
                </td>
                <td
                  style={{ verticalAlign: "top", borderColor: "transparent" }}
                >
                  <strong>Korea</strong>
                  <br />
                  Club &amp; Spa Seoul
                  <br />
                  <br />
                  <strong>Maldives</strong>
                  <br />
                  Vabbinfaru
                  <br />
                  <br />
                  <strong>Morocco</strong>
                  <br />
                  Tamouda Bay
                  <br />
                </td>
                <td
                  style={{ verticalAlign: "top", borderColor: "transparent" }}
                >
                  <strong>Mexico</strong>
                  <br />
                  Cabo Marqués
                  <br />
                  Mayakoba
                  <br />
                  <br />
                  <strong>Seychelles</strong>
                  <br />
                  Seychelles
                  <br />
                  <br />
                  <strong>Vietnam</strong>
                  <br />
                  Lăng Cô
                  <br />
                </td>
              </tr>
            </tbody>
          </table>
          <table
            cellpadding="5"
            style={{
              verticalAlign: "top",
              margin: 0,
              borderColor: "transparent",
              backgroundColor: "#ffffff",
              width: "100%",
            }}
          >
            <tbody>
              <tr>
                <td
                  style={{ verticalAlign: "top", borderColor: "transparent" }}
                  width="150"
                >
                  <img src={imageLogo.faqlogo2} width="120" alt="" />
                </td>
                <td
                  style={{ verticalAlign: "top", borderColor: "transparent" }}
                >
                  <strong>China</strong>
                  <br />
                  Hangzhou
                  <br />
                  Tengchong-Hot
                  <br />
                  Spring Village
                  <br />
                  Xian Lintong
                  <br />
                  Xishuanbanna
                  <br />
                  Zhuhai Phoenix Bay
                  <br />
                  <br />
                  <strong>Maldives</strong>
                  <br />
                  Ihuru
                  <br />
                  Velavaru
                  <br />
                  <br />
                  <strong>Malaysia</strong>
                  <br />
                  Kuala Lumper
                  <br />
                  Pavilion Hotel Kula Lumper
                  <br />
                  <br />
                  <strong>Mauritius</strong>
                  <br />
                  Balaclava
                  <br />
                  <br />
                  <strong>Vietnam</strong>
                  <br />
                  Lăng Cô
                  <br />
                </td>
                <td
                  style={{ verticalAlign: "top", borderColor: "transparent" }}
                >
                  <strong>Indonesia</strong>
                  <br />
                  Bintan
                  <br />
                  <br />
                  <strong>India</strong>
                  <br />
                  Bangalore
                  <br />
                  <br />
                  <strong>Laos</strong>
                  <br />
                  Maison Souvannaphoum
                  <br />
                  <br />
                  <strong>Morocco</strong>
                  <br />
                  Riads Collection Morocco
                  <br />
                  <br />
                  <strong>Seychelles</strong>
                  <strong>Thailand</strong>
                  <br />
                  Laguna Phuket
                  <br />
                  Angsana Villas Resort Phuket
                  <br />
                </td>
              </tr>
            </tbody>
          </table>
          <table
            cellpadding="5"
            style={{
              verticalAlign: "top",
              margin: 0,
              borderColor: "transparent",
              backgroundColor: "#ffffff",
              width: "100%",
            }}
          >
            <tbody>
              <tr>
                <td
                  style={{ verticalAlign: "top", borderColor: "transparent" }}
                  width="150"
                >
                  <img src={imageLogo.faqlogo3} width="120" alt="" />
                </td>
                <td
                  style={{ verticalAlign: "top", borderColor: "transparent" }}
                >
                  <strong>Thailand</strong>
                  <br />
                  Phuket
                  <br />
                  <br />
                  <strong>Indonesia</strong>
                  <br />
                  Bintan
                  <br />
                </td>
              </tr>
            </tbody>
          </table>
          <table
            cellpadding="5"
            style={{
              verticalAlign: "top",
              margin: 0,
              borderColor: "transparent",
              backgroundColor: "#ffffff",
              width: "100%",
            }}
          >
            <tbody>
              <tr>
                <td
                  style={{ verticalAlign: "top", borderColor: "transparent" }}
                  width="150"
                >
                  <img src={imageLogo.faqlogo4} width="120" alt="" />
                </td>
                <td
                  style={{ verticalAlign: "top", borderColor: "transparent" }}
                >
                  <strong>Cuba</strong>
                  <br />
                  Cayo Santa Maria
                  <br />
                </td>
              </tr>
            </tbody>
          </table>
          <table
            cellpadding="5"
            style={{
              verticalAlign: "top",
              margin: 0,
              borderColor: "transparent",
              backgroundColor: "#ffffff",
              width: "100%",
            }}
          >
            <tbody>
              <tr>
                <td
                  style={{ verticalAlign: "top", borderColor: "transparent" }}
                  width="150"
                >
                  <img src={imageLogo.faqlogo5} width="120" alt="" />
                </td>
                <td
                  style={{ verticalAlign: "top", borderColor: "transparent" }}
                >
                  <strong>Thailand</strong>
                  <br />
                  Dusit Thani Pool Villas Phuket
                  <br />
                  Laguna Holiday Club Phuket Resort
                  <br />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      ),
      ru: <div />,
      cn: <div />,
    },
  },
  {
    categoryId: 2,
    question: "How does the exchange programme work?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Participating owners can exchange part of their annual entitlement
            for a complimentary stay at any destination within the network.
          </p>
          <p>
            An owner deposits 15 days of his annual entitlement into the
            exchange pool. These days then are attributed a monetary value based
            on the actual average daily rate for the past year.
          </p>
          <p>
            The monetary value deposited can then be used to redeem for rooms
            and villas at participating properties at the best available rate at
            time of booking.
          </p>
          <p>
            The owner services team administers the exchange programme including
            participating properties, making reservations, recording
            redemptions, and the availability of days remaining of each
            participating property.
          </p>
        </div>
      ),
      ru: <div />,
      cn: <div />,
    },
  },
  {
    categoryId: 2,
    question: "How is the value of my days deposited calculated?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            The actual average daily rate for the past year is used to value
            your deposited days into the exchange programme. This is considered
            the most appropriate basis as it represents the market demand for a
            particular property on a year-round basis.
          </p>
          <p>
            For example, if the average achieved daily rate for your property is
            USD 500, then 15 days of your annual entitlement deposited would
            equate to USD 7,500 (i.e. USD 500 x 15 days) which would be
            available for redemption at participating properties within the
            network.
          </p>
          <p>
            For newly opened properties, the budgeted average daily rate will be
            used for that calendar year.
          </p>
        </div>
      ),
      ru: <div />,
      cn: <div />,
    },
  },
  {
    categoryId: 2,
    question: "How do I make a reservation?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Bookings can be requested via the centralized owner services team.
          </p>
          <p>
            The owner services team will check the availability and the best
            available rate of the property requested.
          </p>
          <p>
            A confirmation of your reservation will then be sent to you along
            with the value redeemed and your remaining balance for redemption.
          </p>
          <p>
            Reservation requests operate on a first come, first served basis.
          </p>
        </div>
      ),
      ru: <div />,
      cn: <div />,
    },
  },
  {
    categoryId: 2,
    question:
      "Does my room reservation made under the Exchange Program include breakfast?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            No, your room reservation made under the Exchange Program does not
            include breakfast. It is for room only.
          </p>
        </div>
      ),
      ru: <div />,
      cn: <div />,
    },
  },
  {
    categoryId: 2,
    question: "How is value redeemed?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Your value can be redeemed at participating properties based upon
            best available rate (BAR) at the time of booking.
          </p>
          <p>
            For example, say you have USD 7,500 and would like to stay 5 days at
            a participating property in the network, which has a best available
            rate of USD 600 per day for the period you would like to stay. Your
            stay would cost USD 3,000 (i.e. USD 600 x 5 days) and you would have
            a balance of USD 4,500 remaining for redemption.
          </p>
        </div>
      ),
      ru: <div />,
      cn: <div />,
    },
  },
  {
    categoryId: 2,
    question: "Are there blackout dates?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Blackout dates may apply and may vary between each location subject
            to your rental agreement.
          </p>
        </div>
      ),
      ru: <div />,
      cn: <div />,
    },
  },
  {
    categoryId: 2,
    question: "Where can I stay?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            You may stay at any property participating in the exchange
            programme, subject to availability, and providing you have
            sufficient value for redemption.
            <br />
            Once all days are utilised in a particular property (redeemed nights
            equal deposited nights), the property is no longer available for
            exchange.
          </p>
          <p>
            <strong>Current participating properties</strong>
          </p>
          <ul>
            <li>
              - Banyan Tree – Bangkok, Bintan, Cabo Marqués, Lang Co, Huangshan,
              Lijiang, Mayakoba, Phuket Double Pool Villas &amp; Phuket Resort
              and Ungasan
            </li>
            <li>
              - Angsana – Bintan, Lang Co, Laguna Phuket and Villas Resort
              Phuket
            </li>
            <li>- Cassia – Phuket</li>
            <li>- Laguna Phuket – Dusit Thani Pool Villas</li>
          </ul>
        </div>
      ),
      ru: <div />,
      cn: <div />,
    },
  },
  {
    categoryId: 2,
    question:
      "Is there a limit to the number of days I can book per exchange stay?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Yes, you may book up to a maximum of five (5) days only for each
            stay.
          </p>
        </div>
      ),
      ru: <div />,
      cn: <div />,
    },
  },
  {
    categoryId: 2,
    question: "Can I roll over my unused value to the following year?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            No. The value of days deposited into the exchange programme will
            expire at the end of each year just as owners shall forfeit their
            entitlement to any unused days during the calendar year.
          </p>
        </div>
      ),
      ru: <div />,
      cn: <div />,
    },
  },
  {
    categoryId: 2,
    question: "Can I book more than one property for a stay?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            No, multiple properties cannot be booked at one time for a stay
            under the exchange programme. However, you may book additional
            properties if making a normal paid reservation and use your
            Sanctuary Club membership to receive a discount from the best
            available rate.
          </p>
        </div>
      ),
      ru: <div />,
      cn: <div />,
    },
  },
  {
    categoryId: 2,
    question: "Can my friends use my owners’ entitlement for an exchange?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Yes, subject to the terms and conditions stipulated in your rental
            agreement and compliance with the hotel policy on the maximum number
            of occupants for the property booked.
          </p>
          <p>
            Your guests are also required to be pre-registered with the owner
            services team who will include their names on the reservation.
          </p>
        </div>
      ),
      ru: <div />,
      cn: <div />,
    },
  },
  {
    categoryId: 2,
    question:
      "Can I choose to opt out of the exchange programme after I have enrolled?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            Once you have enrolled in the exchange program, you must continue
            throughout the entire calendar year in 2017. However, you may choose
            to opt out for the following year in 2018 by informing us prior to
            the commencement of the exchange programme in 2018.
          </p>
        </div>
      ),
      ru: <div />,
      cn: <div />,
    },
  },
  {
    categoryId: 3,
    question: "Terms & Conditions",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            1. Enrollment into The Santuary Club shall be automatic for all
            property owners who have their property managed under a hotel
            branded rental scheme operated by the Banyan Tree Group or its
            affiliates. There is no cost to enrol.
          </p>
          <p>
            2. Discounts and privileges may change from time to time and are
            subject to the discretion of the Banyan Tree Group.
          </p>
          <p>
            3. All participating owners shall deposit 15 days of owners use time
            into the exchange program. This shall be a fixed amount.
          </p>
          <p>
            4.The deposited owners use time will be made at the beginning of
            each year (a pro-rata amount will apply for owners who purchased
            property during the year).
          </p>
          <p>
            5. The deposited owners use time shall be converted to value based
            upon the achieved daily rate (USD equivalent) of the property for
            the preceding year. For example, if the achieved daily rate were USD
            500, 15 days would equate to USD 7,500. Where the property is a new
            property, the budgeted average daily rate shall be used for the
            first year.
          </p>
          <p>
            6. Unused value cannot be carried forward or borrowed and cannot be
            topped up by cash. They are valid only for the current year.
          </p>
          <p>
            7. Booking requests should be made via the owner services team who
            will then co-ordinate the booking with the hotel.
          </p>
          <p>8. Reservations are on a first come, first served basis.</p>
          <p>9. Reservations are subject to availability.</p>
          <p>
            10. No booking of multiple properties is allowed. That is, only one
            property may be booked per exchange.
          </p>
          <p>
            11. Owners may book an exchange for family and friends but must
            pre-register the guests staying during the exchange with the owner
            services team.
          </p>
          <p>
            12. If a booking is confirmed and subsequently cancelled (or there
            is a no show), the value of the booking may be forfeited in
            accordance with the hotel’s cancellation policy.
          </p>
          <p>
            13. No fees shall be charged to owners for exchanges. However, we
            reserve the right to introduce fees in the future.
          </p>
          <p>
            14. Black-out dates may apply for each location and may vary between
            locations and are subject to the terms and condition set out in the
            rental scheme agreements.
          </p>
          <p>
            15. Banyan Tree Group reserves the right to change the terms and
            conditions.
          </p>
        </div>
      ),
      ru: <div />,
      cn: <div />,
    },
  },
];

export { faqs, category };



// WEBPACK FOOTER //
// ./src/data/SanctuaryClub/faq.js